var render = function render() {
    var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
    return _c('div', {
        ref: "container",
        class: _vm.$style.container,
        style: {
            height: _vm.heightAuto ? 'auto' : '100%',
            overflow: _vm.heightAuto ? 'visible' : 'auto'
        }
    });
};
var staticRenderFns = [];
export { render, staticRenderFns };
